import { createApp } from 'vue';
import {getJsonFromElement} from "@/js/utils/getJsonFromElement";


/**
 * @typedef {Object} MountVueComponentOptions
 * @property {string} [jsonId]
 * @property {Record<string, any>} [props]
 * @property {Array<any>} [plugins]
 */

/**
 * Vueインスタンスの生成処理
 * @param {String} mountId
 * @param {Object} component
 * @param {MountVueComponentOptions} [options]
 */
export function mountVueComponentToElement(mountId, component, options = {}) {
    const {
            jsonId = null,
            props = {},
            plugins = [],
    } = options;

    const mountEl = document.getElementById(mountId);
    if (!mountEl||!component) {
        return;
    }

    const propsFromOption = props ?? {};
    const propsFromJson = jsonId ? (getJsonFromElement(jsonId) ?? {}) : {};
    // jsonを優先
    const resolvedProps = { ...propsFromOption, ...propsFromJson };
    const app = createApp(component, resolvedProps);

    plugins.forEach(plugin => app.use(plugin));

    return app.mount(mountEl);
}
